import {
  AddClientIcon,
  ConnectDevicesIcon,
  DefinedNetworkIcon,
  DenoiseIcon,
  DetectorIcon,
  SaturationIcon,
  SpeedTestIcon,
  TriggersIcon,
} from "@ubnt/icons";
import { IHeroSection } from "pages/LayoutComponents/Hero/Hero.types";
import React from "react";
import { ICondensedFeatureItem } from "pages/LayoutComponents/CondensedFeatureGrid/CondensedFeatureGrid.types";
import heroJpg from "./assets/videos/hero.jpg";
import heroMp4 from "./assets/videos/hero.mp4";
import outdoor1Mp4 from "./assets/feature-tiles/outdoor-1.mp4";
import outdoor1Jpg from "./assets/feature-tiles/outdoor-1.jpg";
import outdoor2Mp4 from "./assets/feature-tiles/outdoor-2.mp4";
import outdoor2Jpg from "./assets/feature-tiles/outdoor-2.jpg";
import outdoor3Mp4 from "./assets/feature-tiles/outdoor-3.mp4";
import outdoor3Jpg from "./assets/feature-tiles/outdoor-3.jpg";
import outdoor4Mp4 from "./assets/feature-tiles/outdoor-4.mp4";
import outdoor4Jpg from "./assets/feature-tiles/outdoor-4.jpg";
import megaCapacity1Mp4 from "./assets/feature-tiles/mega-capacity-1.mp4";
import megaCapacity1Jpg from "./assets/feature-tiles/mega-capacity-1.jpg";
import megaCapacity2Mp4 from "./assets/feature-tiles/mega-capacity-2.mp4";
import megaCapacity2Jpg from "./assets/feature-tiles/mega-capacity-2.jpg";
import megaCapacity3Mp4 from "./assets/feature-tiles/mega-capacity-3.mp4";
import megaCapacity3Jpg from "./assets/feature-tiles/mega-capacity-3.jpg";
import megaCapacity4Mp4 from "./assets/feature-tiles/mega-capacity-4.mp4";
import megaCapacity4Jpg from "./assets/feature-tiles/mega-capacity-4.jpg";

export const HERO_SECTIONS = [
  {
    id: 0,
    icon: <ConnectDevicesIcon size="original" color="#fff" />,
    label: "Extend WiFi Over Campuses",
    poster: heroJpg,
    src: heroMp4,
    playbackTimeInSeconds: 24,
  },
] satisfies IHeroSection[];

export const FEATURE_COMPLETE_TILES = [
  {
    id: "all-environments",
    assets: {
      src: outdoor1Mp4,
      poster: outdoor1Jpg,
      icon: <DefinedNetworkIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.outdoor.featureTiles.environment.title",
    description: "wifi.outdoor.featureTiles.environment.description",
  },
  {
    id: "high-speed",
    assets: {
      src: outdoor2Mp4,
      poster: outdoor2Jpg,
      icon: <SpeedTestIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.outdoor.featureTiles.highSpeed.title",
    description: "wifi.outdoor.featureTiles.highSpeed.description",
  },
  {
    id: "antenna-versatility",
    assets: {
      src: outdoor3Mp4,
      poster: outdoor3Jpg,
      icon: <TriggersIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.outdoor.featureTiles.antenna.title",
    description: "wifi.outdoor.featureTiles.antenna.description",
  },
  {
    id: "interference-free",
    assets: {
      src: outdoor4Mp4,
      poster: outdoor4Jpg,
      icon: <DenoiseIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.outdoor.featureTiles.interferenceFree.title",
    description: "wifi.outdoor.featureTiles.interferenceFree.description",
  },
  {
    id: "10gigabit-performance",
    assets: {
      src: megaCapacity3Mp4,
      poster: megaCapacity3Jpg,
      icon: <SpeedTestIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.megaCapacity.featureTiles.10gigabit.title",
    description: "wifi.megaCapacity.featureTiles.10gigabit.description",
    isSelectedModelsOnly: true,
  },
  {
    id: "weatherproof",
    assets: {
      src: megaCapacity4Mp4,
      poster: megaCapacity4Jpg,
      icon: <SaturationIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.megaCapacity.featureTiles.weatherproof.title",
    description: "wifi.megaCapacity.featureTiles.weatherproof.description",
    isSelectedModelsOnly: true,
  },
  {
    id: "directional-antenna",
    assets: {
      src: megaCapacity1Mp4,
      poster: megaCapacity1Jpg,
      icon: <DetectorIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.megaCapacity.featureTiles.antenna.title",
    description: "wifi.megaCapacity.featureTiles.antenna.description",
    isSelectedModelsOnly: true,
  },
  {
    id: "1500-client-capacity",
    assets: {
      src: megaCapacity2Mp4,
      poster: megaCapacity2Jpg,
      icon: <AddClientIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "wifi.megaCapacity.featureTiles.clientCapacity.title",
    description: "wifi.megaCapacity.featureTiles.clientCapacity.description",
    isSelectedModelsOnly: true,
  },
] satisfies Array<ICondensedFeatureItem>;
